// TODO: src/appLogic/organizationTable/に移動する

import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { getBusinessManager } from '@/businessRepository/organizationTable/businessManage';

/**
 *
 */
export default async (): Promise<IBusiness[]> => {
  const businesses = await getBusinessManager().getAll();
  businesses.forEach((business) => {
    if (business?.recommend && business?.recommend.length > 0) {
      // recommendが存在しないならわざわざ初期化しない
      // recommendが存在しないときminusInventoryも存在しない
      business.recommend = [];
      getBusinessManager().register(business);
    }
  });
  return businesses;
};
